import { render, staticRenderFns } from "./the-dashboard-navigation-item.vue?vue&type=template&id=206f6f48"
import script from "./the-dashboard-navigation-item.vue?vue&type=script&lang=js"
export * from "./the-dashboard-navigation-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports